import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Box, useTheme } from "@mui/material";
import DialogCancelButton from "../input/button/DialogCancelButton";
import DialogConfirmButton from "../input/button/DialogConfirmButton";

const DialogWrapper = ({
    children,
    open,
    onClose,
    fullWidth = true,
    fullScreen = false,
    title,
    onCancel = null,
    onConfirm = null,
    labelCancel = "Cancelar",
    labelConfirm = "Confirmar",
    maxWidth = undefined,
}) => {

    const theme = useTheme();
    const hasActions = Boolean(onCancel) || Boolean(onConfirm);

    return (
        <Dialog open={open} onClose={onClose} fullWidth={fullWidth} fullScreen={fullScreen} maxWidth={maxWidth}>
            {title ? <DialogTitle>{title}</DialogTitle> : null}
            <DialogContent>
                <Box sx={{ marginTop: theme.spacing(1) }}>
                    {children}
                </Box>
            </DialogContent>
            {
                hasActions ? (
                    <DialogActions>
                        {Boolean(onCancel) ? <DialogCancelButton onClick={onCancel} label={labelCancel} /> : null}
                        {Boolean(onConfirm) ? <DialogConfirmButton onClick={onConfirm} label={labelConfirm} /> : null}
                    </DialogActions>
                ) : null
            }
        </Dialog>
    )
}

export default DialogWrapper;
